import reduce from 'ramda/src/reduce';
export default function getSocialProfileData(details) {
  return reduce(function (acc, _ref) {
    var _ref$code = _ref.code,
        detailCode = _ref$code === void 0 ? '' : _ref$code,
        _ref$value = _ref.value,
        value = _ref$value === void 0 ? '' : _ref$value;
    var prop = detailCode.split('.')[2];

    if (prop) {
      acc[prop] = value;
    }

    return acc;
  }, {}, details);
}